// Mock data for ONEVO Premium Training Studio

export const studioInfo = {
  name: "ONEVO",
  tagline: "Premium Training Studio",
  est: "Est. 2026",
  address: "Via Pastrengo, 15",
  city: "10128 Torino TO",
  phone: "375 149 4230",
  phoneHref: "+393751494230",
  rating: "5,0",
  reviews: "16",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Via+Pastrengo+15+Torino",
};

export const marqueeItems = [
  "Attrezzature Premium",
  "Personal Training",
  "Nutrizione Sportiva",
  "Ambiente Curato",
  "Risultati Garantiti",
  "Aperto Lun \u2013 Sab",
];

export const heroImage =
  "https://images.pexels.com/photos/4753890/pexels-photo-4753890.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=1600";

export const aboutImage =
  "https://customer-assets.emergentagent.com/job_risultati-garantiti/artifacts/xk54xtv9_IMG_8299.jpeg";

export const stats = [
  { value: "5,0", suffix: "\u2605", label: "Valutazione media Google" },
  { value: "16", suffix: "+", label: "Recensioni verificate" },
  { value: "06:00", suffix: "", label: "Apertura mattutina" },
  { value: "100", suffix: "%", label: "Clienti soddisfatti" },
];

export const galleryImages = [
  {
    src: "https://customer-assets.emergentagent.com/job_risultati-garantiti/artifacts/p4tkcn2n_IMG_8303.jpeg",
    alt: "Sala attrezzi ONEVO con rack e macchinari Sidea",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_risultati-garantiti/artifacts/uhrzcuhi_IMG_8302.jpeg",
    alt: "Chest press TechnoGym ONEVO",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_risultati-garantiti/artifacts/4rndguqr_IMG_8301.jpeg",
    alt: "Macchinario adductor Technogym",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_risultati-garantiti/artifacts/2wl22nwc_IMG_8300.jpeg",
    alt: "Area squat rack e panca ONEVO",
  },
];

export const services = [
  {
    num: "01",
    icon: "Dumbbell",
    title: "Personal Training",
    text: "Programmi personalizzati costruiti intorno ai tuoi obiettivi. Ogni sessione \u00e8 diversa, ogni sessione ti avvicina al risultato.",
    tag: "Su appuntamento",
  },
  {
    num: "02",
    icon: "Salad",
    title: "Nutrizione Sportiva",
    text: "Piani alimentari integrati all'allenamento. Perch\u00e9 i risultati si costruiscono anche fuori dalla sala pesi.",
    tag: "Consulenza inclusa",
  },
  {
    num: "03",
    icon: "Activity",
    title: "Sala Attrezzi",
    text: "Macchinari di ultima generazione, sempre perfettamente manutenuti. Uno spazio dove allenarsi \u00e8 un piacere.",
    tag: "Su prenotazione",
  },
  {
    num: "04",
    icon: "Gauge",
    title: "Analisi della Composizione Corporea",
    text: "Misurazione professionale per capire da dove parti e monitorare ogni progresso con precisione.",
    tag: "Inclusa nel piano",
  },
  {
    num: "05",
    icon: "Flame",
    title: "Coaching Motivazionale",
    text: "I risultati dipendono dalla costanza. Ti aiutiamo a costruire abitudini solide e a mantenerle nel tempo.",
    tag: "Parte del percorso",
  },
  {
    num: "06",
    icon: "MessageCircle",
    title: "Consulenza Iniziale",
    text: "Una prima sessione conoscitiva per valutare il punto di partenza e costruire insieme il tuo percorso.",
    tag: "Su prenotazione",
  },
];

export const testimonials = [
  {
    initials: "ML",
    name: "Maurizio Lasorsa",
    when: "1 mese fa \u00b7 Google",
    text: "Un'esperienza di allenamento superiore. Ho frequentato diversi centri in passato, ma questo nuovo spazio si distingue in tutto. Fin dal primo giorno vieni accolto con gentilezza e un calore unici. L'igiene \u00e8 impeccabile in ogni angolo.",
  },
  {
    initials: "DM",
    name: "Dario Miceli",
    when: "1 mese fa \u00b7 Google",
    text: "Semplicemente fantastico! Dopo aver visto molte palestre, posso dire di aver trovato quella definitiva. Pulizia impeccabile, attrezzi moderni e un team eccezionale. Consigliatissimo, 5 stelle meritate.",
  },
  {
    initials: "PI",
    name: "Pasquale Iacobone",
    when: "1 mese fa \u00b7 Google",
    text: "Ho frequentato diversi centri, ma ONEVO \u00e8 su un altro livello. L'ambiente \u00e8 curato nei minimi dettagli, moderno e perfetto per chi cerca un'esperienza davvero premium focalizzata sui risultati.",
  },
];

export const goals = [
  "Dimagrimento",
  "Aumento massa",
  "Tonificazione",
  "Performance",
  "Altro",
];

export const hours = [
  { days: "Lun \u2013 Ven", time: "06:00 \u2013 21:00" },
  { days: "Sabato", time: "08:00 \u2013 14:00" },
  { days: "Domenica", time: "Chiuso" },
];
